export default __webpack_public_path__ + "static/media/icon_play.589b7745.svg";